export default {
  headerContent: {
    title: 'Generali Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Generali Sigorta Konut Sigortası',
    description: {
      title: 'Generali Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Konut sigortası, konut ve konut içerisinde bulanan eşyalarda oluşabilecek risklere karşı güvence sağlamaktadır.',
        'Konut sigortası yangın, hırsızlık ve deprem gibi risklerin oluşması sonucu oluşacak maddi kayıplara karşı sigortalıyı ve bütçesini koruma altına almaktadır.'
      ]
    },
    subContent: {
      title: 'Generali Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Cam kırılması',
            'Dahili su',
            'Deprem ',
            'Dolu',
            'Duman',
            'Enkaz kaldırma ',
            'Fırtına',
            'G.l.h.h.k.n.h.t',
            'Hava araçları çarpması',
            'Hırsızlık',
            'Kar ağırlığı',
            'Kara araçları çarpması',
            'Kira kaybı',
            'Kombi veya klima bakım hizmeti',
            'Konut asistans',
            'Misafir eşyaları ',
            'Sel ve su baskını',
            'Yangın mali sorumluluk',
            'Yangın izolasyon eksikliği',
            'Yer kayması teminatını kapsar.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Generali Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Generali Sigorta Konut Sigortası Ek Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Aile hukuksal koruma',
            'Aile sorumluluk teminatı',
            'Alternatif ikametgah masrafları teminatı',
            'Elektronik cihaz',
            'Eşyaların kurtarılma, taşınma ve depolanma masrafları teminatı',
            'Ferdi kaza',
            'Gıda bozulması teminatı',
            'Hukuksal koruma',
            'Kişisel eşyalar gasp/kapkaç',
            'Makine kırılması',
            'Makine kırılması ortak alanlar',
            'Sigortalı adres dışında bulunan eşyalar teminatı',
            'Üçüncü şahıs mali sorumluluk',
            'Yakıt sızması teminatıdır.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta Yardım Hizmetleri Nelerdir?',
      content: [
        {
          paragraph:
            'Generali Sigorta konut sigortası müşterilerine özel olarak aşağıdaki hizmetleri ücretsiz olarak sunmaktadır.',
          subList: [
            'Bilgi Hattı Hizmeti',
            'Tıbbi Bilgi ve Danışmanlık',
            'Ambulans ve Evde Hekim Muayene Hizmeti',
            'Kara Ambulansı ',
            'Su Tesisatı Hizmeti',
            'Elektrik Tesisatı Hizmeti',
            'Çilingir Hizmeti',
            'Cam İşleri Hizmeti',
            'Araç Çekici Hizmeti',
            'Otelde Konaklama Hizmeti',
            'Konutun Korunması ve Gözetim Hizmeti.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Kapsamı Nedir? Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Konut sigortası kapsamı poliçeye eklenmiş olan teminatlara göre değişmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Eşya Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Eşya sigortası, sadece konut içerisinde bulunan eşyaları güvence altına alan sigorta ürünüdür.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası İçin Gerekli Bilgiler Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Brüt metrekare,',
            'Bulunduğu kat,',
            'İnşa bedeli,',
            'Kimlik bilgileri,',
            'Konutun açık adresi,',
            'Eşya bedeli gibi belge ve bilgilerdir.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Hasarsızlık İndirimi Nedir?',
      content: [
        {
          paragraph:
            'Konut sigortasında bulunan hasarsızlık indirimi poliçe vadesi boyunca hiç <strong>hasar olmaması</strong> durumunda kazanılan ekstra indirimdir. Hasarsızlık indirimi sayesinde poliçe fiyatlarınız avantajlı hale gelir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Geçerlilik Süresi Ne Kadar?',
      content: [
        {
          paragraph:
            'Konut sigortası geçerlilik süresi poliçe başlangıç tarihinden itibaren 1 yıldır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Elektronik Eşyayı Karşılar M?',
      content: [
        {
          paragraph:
            'Konut sigortası teminatları arasında elektronik cihaz teminatı bulunması durumunda karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Deprem Hasarını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Konut sigortası teminatları arasında deprem teminatı bulunması durumunda karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Yaptırmak Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Konut sigortası isteğe bağlı bir sigorta ürünüdür. Finansal koruma sağladığı için ihtiyaçtır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Konut Sigortası Mobilya Mini Hasarlarını Kapsar Mı?',
      content: [
        {
          paragraph:
            'Generali Sigorta konut sigortası içeriğinde sunduğu asistans hizmetleri ile mobilyanızda oluşan mini hasarları kapsamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Rutubet Hasarını Karşılar Mı?',
      content: [
        {
          paragraph:
            'İzolasyon eksikliğine bağlı olarak oluşan rutubet hasarları poliçe kapsamı dahilindedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Konut Sigortası Kiracı Tarafından Yaptırılabilir Mi?',
      content: [
        {
          paragraph:
            'Kiracılar konut sigortasını eşyalara ve komşulara karşı olan sorumlulukları korumak için yapılabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Hasar Ödemesi Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Tazminat ödemesi tazminat miktarının belirlenmesinin ardından sigorta şirketi tarafından poliçede yazan bedeli aşmamak kaydıyla hak sahibine yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Sorgulaması Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Konut sigortası sorgulaması gerekli bilgiler girilerek yapılmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Alokasko ekibi bilgilerin girilmesi ardından sizin için en uygun konut sigortası sorgulaması yapar ve size sunar.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Konut sigortası hesaplaması, sigorta şirketinin belirlemiş olduğu risk kriterlerine göre yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Konut sigortası dairenin metrekaresi, değeri ve binanın bulunduğu adrese göre değişmektedir. Bu sebeple net bir fiyat söylemek mümkün değildir.',
          subList: null
        },
        {
          paragraph:
            'Online teklif alarak konut sigortası fiyatlarını değerlendirebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
